import { useTheme } from '../../hooks/useTheme'
import Icon from './Icon'

interface ThemeToggleProps {
  className?: string
}

/**
 * ☀️ / 🌙 主题切换按钮
 * 像素风：方块边框 + emoji 图标
 */
function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, toggle } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggle}
      aria-label={isDark ? '切换到白天模式' : '切换到夜晚模式'}
      title={isDark ? '切换到夜晚模式' : '切换到白天模式'}
      className={`pixel-button pixel-tag inline-flex items-center gap-1.5 ${className}`}
      style={{
        fontSize: '11px',
        padding: '6px 10px',
        minWidth: 'auto',
      }}
    >
      <Icon
        name={isDark ? 'moon' : 'sun'}
        size={14}
        className="transition-transform duration-300"
        style={{ transform: isDark ? 'rotate(-12deg)' : 'rotate(0deg)' }}
      />
      <span>{isDark ? '夜晚' : '白天'}</span>
    </button>
  )
}

export default ThemeToggle